/**
 * 变量模型（物理特有，对应 tech/108 §5）：物理实验的教学核心是控制变量法，
 * 所以自变量/因变量/受控变量在此被提升为一等公民，而不是化学 LabEngine 那种装配关系为核心。
 */

export type VariableRole = "independent" | "dependent" | "controlled";
export type VariableValue = string | number | boolean | null;

export interface Variable {
  id: string;
  label: string;
  role: VariableRole;
  value: VariableValue;
  unit?: string;
}

export class VariableTable {
  private readonly variables = new Map<string, Variable>();

  define(variable: Variable): void {
    this.variables.set(variable.id, { ...variable });
  }

  set(id: string, value: VariableValue): void {
    const existing = this.variables.get(id);
    if (!existing) {
      throw new Error(`[VariableTable] 未定义的变量：${id}`);
    }
    existing.value = value;
  }

  get(id: string): Variable | undefined {
    return this.variables.get(id);
  }

  has(id: string): boolean {
    return this.variables.has(id);
  }

  snapshot(): Record<string, VariableValue> {
    const result: Record<string, VariableValue> = {};
    for (const [id, variable] of this.variables) {
      result[id] = variable.value;
    }
    return result;
  }

  reset(): void {
    for (const variable of this.variables.values()) {
      variable.value = null;
    }
  }
}
